import { useState, useCallback } from 'react';
import { Box, Button } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import apiClient from '../../utils/axiosClient';
import DateRangeSelector from '../../components/DateRangeSelector';

export default function SspSettlement() {
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().startOf('month'));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
  const [downloading, setDownloading] = useState(false);

  const handleDownloadExcel = useCallback(() => {
    if (!startDate || !endDate) return;

    setDownloading(true);
    apiClient
      .get('/api/v1/settle/support/ssp/excel', {
        params: {
          start_date: startDate.format('YYYY-MM-DD'),
          end_date: endDate.format('YYYY-MM-DD'),
        },
        responseType: 'blob',
      })
      .then((res) => {
        const disposition = res.headers['content-disposition'] ?? '';
        const rfcMatch = disposition.match(/filename\*=UTF-8''([^;\n]+)/i);
        const plainMatch = disposition.match(/filename="?([^";\n]+)"?/i);
        const raw = rfcMatch?.[1] ?? plainMatch?.[1] ?? null;
        const filename = raw
          ? decodeURIComponent(raw.trim())
          : `SSP매출_${startDate.format('YYMMDD')}_${endDate.format('YYMMDD')}.xlsx`;
        const url = URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
      })
      .finally(() => setDownloading(false));
  }, [startDate, endDate]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <DateRangeSelector
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
      />
      <Button
        variant="contained"
        size="small"
        onClick={handleDownloadExcel}
        disabled={downloading || !startDate || !endDate}
        sx={{ height: 40 }}
      >
        {downloading ? '다운로드 중...' : '엑셀 다운로드'}
      </Button>
    </Box>
  );
}
